import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import { errorHandler } from "../../../helpers/errorHandler";
import {
    Call,
    CallWithFormData,
    CallWithFormDataFile,
    downloadBlob,
    mergeFormData,
    objectToFormData,
} from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";
import { deleteConfirmModal } from "../../../helpers/DeleteValidate";

const initialState = {
    data: [],
    total: null,
    degreeKeys: [],
    statusKeys: [],
};

export const GenerationalTable = createSlice({
    name: "GenerationalTable",
    initialState,
    reducers: {
        setData: (state, action) => {
            state.data = action.payload.data;
            state.total = action.payload.total;
            state.degreeKeys = action.payload.degreeKeys;
            state.statusKeys = action.payload.statusKeys;
        },
        clearData: (state) => {
            state.data = initialState.data;
            state.total = initialState.total;
            state.degreeKeys = initialState.degreeKeys;
            state.statusKeys = initialState.statusKeys;
        },
    },
});

export const { setData, clearData } = GenerationalTable.actions;

export default GenerationalTable.reducer;

export const startGetGenerationalTable = ({
    status,
    cycle,
    period,
    coordination_id,
    is_export,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        params.set(
            "status",
            status.map((s) => s.value).join(",")
        );
        params.set("cycle", cycle.name);
        if (period) {
            params.set("period", period);
        }
        if (coordination_id) {
            params.set("coordination_id", coordination_id);
        }
        if (is_export) {
            params.set("is_export", 1);
        }

        const url = `operators/reports/academic-records/generational/table`;

        if (is_export) {
            const file = await CallWithFormDataFile(
                url,
                "GET",
                params.toString()
            );
            downloadBlob(file, "Tabla generacional.xlsx");
        } else {
            const resp = await Call(url, "GET", params.toString());
            if (resp.success) {
                dispatch(setData(resp.success));
            } else {
                errorHandler(resp);
            }
        }

        dispatch(stopUILoading());
    };
};
